var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33968 6.99971L12.9459 2.38186C13.3139 2.01309 13.3139 1.39535 12.9459 1.02658C12.5778 0.657808 11.9613 0.657808 11.5933 1.02658L6.98712 5.64442L2.37858 1.02893C2.01055 0.660156 1.39405 0.660156 1.02602 1.02893C0.657993 1.3977 0.657993 2.01544 1.02602 2.38421L5.63456 6.99971L1.02836 11.6175C0.660337 11.9863 0.660337 12.6041 1.02836 12.9728C1.21121 13.156 1.46203 13.25 1.7105 13.25C1.95898 13.25 2.19574 13.1584 2.39264 12.9728L7.00118 8.35499L11.6097 12.9728C11.7926 13.156 12.0434 13.25 12.2919 13.25C12.5403 13.25 12.7771 13.1584 12.974 12.9728C13.342 12.6041 13.342 11.9863 12.974 11.6175L8.33968 6.99971Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.0ed88794.svg";
export { ForwardRef as ReactComponent };